export default "__VITE_ASSET__rU$a8nY4__"